import { render, staticRenderFns } from "./ModalIncluirDevedor.vue?vue&type=template&id=42028fea&scoped=true&"
import script from "./ModalIncluirDevedor.vue?vue&type=script&lang=js&"
export * from "./ModalIncluirDevedor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42028fea",
  null
  
)

export default component.exports